import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTelegram } from './useTelegram.js';

const ROOT_PATHS = new Set(['/', '/dashboard']);

export const TelegramNavigationBridge: React.FC = () => {
  const { adapter, environment } = useTelegram();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!environment.isTelegram || ROOT_PATHS.has(location.pathname)) return undefined;
    return adapter.showBackButton(() => navigate(-1));
  }, [adapter, environment.isTelegram, location.pathname, navigate]);

  return null;
};
